import { render, staticRenderFns } from "./SettingHomepageCategoryDashboard.vue?vue&type=template&id=218a6f90&"
import script from "./SettingHomepageCategoryDashboard.vue?vue&type=script&lang=js&"
export * from "./SettingHomepageCategoryDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports